import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClassify2Line = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.5858 2.75742C16.3668 1.97637 17.6332 1.97637 18.4142 2.75742L21.2426 5.58584C22.0237 6.36689 22.0237 7.63322 21.2426 8.41427L18.4142 11.2427C17.6332 12.0237 16.3668 12.0237 15.5858 11.2427L12.7574 8.41427C11.9763 7.63322 11.9763 6.36689 12.7574 5.58584L15.5858 2.75742ZM17 4.17163L14.1716 7.00006L17 9.82849L19.8284 7.00006L17 4.17163Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 3.00009C10.1046 3.00009 11 3.89552 11 5.00009V9.00009C11 10.1047 10.1046 11.0001 9 11.0001H5C3.89543 11.0001 3 10.1047 3 9.00009V5.00009C3 3.89552 3.89543 3.00009 5 3.00009H9ZM9 5.00009H5V9.00009H9V5.00009ZM21 15.0001C21 13.8955 20.1046 13.0001 19 13.0001H15C13.8954 13.0001 13 13.8955 13 15.0001V19.0001C13 20.1047 13.8954 21.0001 15 21.0001H19C20.1046 21.0001 21 20.1047 21 19.0001V15.0001ZM19 15.0001V19.0001H15V15.0001H19ZM9 13.0001C10.1046 13.0001 11 13.8955 11 15.0001V19.0001C11 20.1047 10.1046 21.0001 9 21.0001H5C3.89543 21.0001 3 20.1047 3 19.0001V15.0001C3 13.8955 3.89543 13.0001 5 13.0001H9ZM9 15.0001H5V19.0001H9V15.0001Z"
	})]
});
export default SvgClassify2Line;
